import Component from '@glimmer/component';

/**
 * @param {Array}               deliveries
 * @param {Function}            onMarkDeliveryAsPickedUpTask
 * @param {Array}               selectedDeliveries
 * @param {Function}            selectAllDeliveries
 * @param {Function}            clearAllSelectedDeliveries
 * @param {Function}            toggleDelivery
 * @param {String}              sortBy
 * @param {String}              sortDirection
 * @param {Function}            setSortBy
 * @param {Function}            setSortDirection
 */
export default class DeliveryList extends Component {
  get sortBy() {
    return this.args.sortBy || 'Date received';
  }

  get sortDirection() {
    return this.args.sortDirection || 'Most to least recent';
  }

  get sortedDeliveries() {
    return this.args.deliveries ?? [];
  }

  get allDeliveriesSelected() {
    const selectedCount = this.args.selectedDeliveries?.length;
    const totalCount = this.sortedDeliveries.length;
    return selectedCount === totalCount;
  }

  get isSelectAllIndeterminate() {
    const selectedCount = this.args.selectedDeliveries?.length;
    const totalCount = this.sortedDeliveries.length;
    return selectedCount > 0 && selectedCount !== totalCount;
  }
}
